// plugins/baseAlert.js
import { createVNode, render } from 'vue';
import BaseAlert from '@/Components/BaseAlert.vue';

let currentContainer = null;

function spawnAlert(options) {
  // Clean up existing alert if one exists
  if (currentContainer) {
    render(null, currentContainer);
    currentContainer.remove();
    currentContainer = null;
  }

  const container = document.createElement('div');
  document.body.appendChild(container);
  currentContainer = container;

  const props = {
    ...options,
    visible: true,
    'onUpdate:visible': (v) => {
      if (!v && currentContainer) {
        render(null, currentContainer);
        currentContainer.remove();
        currentContainer = null;
      }
    }
  };

  const vnode = createVNode(BaseAlert, props);
  render(vnode, container);
}

export default {
  install(app) {
    app.config.globalProperties.$alert = spawnAlert;
    app.provide('baseAlert', spawnAlert);
  }
};